import React from 'react';
import { NODE_CATALOG } from 'features/agents/WorkflowEditor/nodeCatalog';
import { iconFor, logoFor, logoNeedsAdaptive, accentFor, accentTint, accentEdge, accentIconColor } from 'features/agents/WorkflowEditor/nodeAppearance';

/**
 * A node's mark: its icon on a neutral tile. One component, so the canvas,
 * the palette, the settings header and a run's graph all show the same thing
 * at the same size.
 *
 * Only a trigger's tile is tinted (brand soft); everything else is the
 * sunken surface with a hairline, in tokens, so it holds in light and dark.
 * A node from a connected app (or Lucid) wears that logo instead of an icon.
 */
export default function NodeMark({ kind, size = 24, title }) {
  const spec = NODE_CATALOG[kind] || {};
  const logo = logoFor(kind);
  const Icon = iconFor(kind);
  const accent = accentFor(kind);
  const inner = Math.round(size * 0.58);

  return (
    <span
      role="img"
      aria-label={spec.displayName || kind}
      title={title}
      style={{
        width: size,
        height: size,
        borderRadius: Math.max(6, Math.round(size * 0.28)),
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: accentTint(accent),
        border: `1px solid ${accentEdge(accent)}`,
        overflow: 'hidden',
      }}
    >
      {logo
        ? <img src={logo} alt="" className={logoNeedsAdaptive(logo) ? 'node-icon-adaptive' : undefined} style={{ width: inner, height: inner, objectFit: 'contain' }} />
        : <Icon style={{ width: inner, height: inner, color: accentIconColor(accent) }} strokeWidth={1.9} />}
    </span>
  );
}
